// actions/connect/disconnect.js

import { attachAuth } from '../../utils/authService';
//import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectDisconnectHasErrored(bool) {
  return {
    type: 'CONNECT_DISCONNECT_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectDisconnectIsLoading(bool) {
  return {
    type: 'CONNECT_DISCONNECT_IS_LOADING',
    isLoading: bool
  };
}

export function connectDisconnectFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_DISCONNECT_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectDisconnectFetchData(host, instanceId, flowId, contactId, userName) {
  return (dispatch) => {
    dispatch(connectDisconnectIsLoading(true));
    dispatch(connectDisconnectHasErrored(false));
    fetch(host + 'connect/disconnect', {
      method: 'post',
      body: JSON.stringify({ ContactFlowId: flowId, InstanceId: instanceId, ContactId: contactId, Username: userName }),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectDisconnectFetchDataSuccess(result));
            dispatch(connectDisconnectHasErrored(false));
            dispatch(connectDisconnectIsLoading(false));
            //PubSub.publish('connect.chat.response', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectDisconnectHasErrored(true));
            dispatch(connectDisconnectIsLoading(false));
            //PubSub.publish('connect.chat.error');
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectDisconnectHasErrored(true));
      dispatch(connectDisconnectIsLoading(false));
      //PubSub.publish('connect.chat.error');
    });
  };
}

export function connectDisconnectSyncronous(host, instanceId, flowId, contactId, userName) {
  let url     = new URL(host + 'connect/disconnect');
  let http    = new XMLHttpRequest();
  var headers = attachAuth();
  
  http.open('POST', url, false);
  
  for (var key of headers.keys()) {
    http.setRequestHeader(key, headers.get(key));
  }
  
  http.send(JSON.stringify({ ContactFlowId: flowId, InstanceId: instanceId, ContactId: contactId, Username: userName }));
}